import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { createContest } from '../api';

const AdminCreateContestPage = () => {
  const navigate = useNavigate();
  const { getToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    total_prize: 0,
    status: 'open',
    category: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'total_prize' ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const token = await getToken();
      await createContest(formData, token);
      alert('Contest created successfully!');
      navigate('/contests');
    } catch (err) {
      alert('Error creating contest: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="container mx-auto max-w-2xl">
        <button
          onClick={() => navigate('/admin')}
          className="mb-4 px-4 py-2 bg-secondary text-surface rounded-lg hover:bg-secondary/90 transition"
        >
          ← Back to Dashboard
        </button>

        <div className="bg-surface rounded-lg shadow-lg p-8 border-t-4 border-primary">
          <h1 className="text-4xl font-bold mb-8 text-secondary">✨ Create New Contest</h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-text font-semibold mb-2">Contest Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                placeholder="Enter contest title"
              />
            </div>

            <div>
              <label className="block text-text font-semibold mb-2">Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none h-32"
                placeholder="Enter contest description"
              />
            </div>

            <div>
              <label className="block text-text font-semibold mb-2">Category</label>
              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                placeholder="e.g., Music, Photography, Dance"
              />
            </div>

            <div>
              <label className="block text-text font-semibold mb-2">Prize Pool (₦)</label>
              <input
                type="number"
                name="total_prize"
                value={formData.total_prize}
                onChange={handleChange}
                className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                placeholder="Enter total prize amount"
              />
            </div>

            <div>
              <label className="block text-text font-semibold mb-2">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none"
              >
                <option value="open">🟢 Open</option>
                <option value="closed">🔴 Closed</option>
                <option value="voting">🗳️ Voting</option>
              </select>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-surface font-bold py-3 rounded-lg hover:bg-primary/90 transition disabled:bg-gray-400"
            >
              {loading ? '⏳ Creating...' : '✨ Create Contest'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminCreateContestPage;
